import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getNotifications() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-notifications`);
    return response

  } catch (error) {
    console.error('Error al obtener las notificaciones', error);
  }
}